import { I01DEPBOUCECS_State } from '@batical/types/src'

const I01DEPBOUCECS: I01DEPBOUCECS_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  tube_dep_uuid: 'F2AFEABC-AB60-4E1D-B96E-0A07752875FA',
  in_temp_dep_boucleECS: 55.0,
  in_temp_dep_moyenne_ambiance: 15.0,
  dep_isolantSelected: 'iso1',
  in_dep_epaisseur: 0.0,
  in_dep_long_tuyauterie: 20.0,
  in_dep_boucle_ailee: 900.0,
  pdcUnitSelected_uuid: '6D91E213-CFEA-4A37-A3FF-5A3D10E60966',
  tube_ret_uuid: 'F2AFEABC-AB60-4E1D-B96E-0A07752875FA',
  in_ret_temp_ambiance: 0.0,
  in_ret_epaisseur: 0,
  in_ret_long_tuyauterie: 0.0,
  ret_isolantSelected: 'iso2',
  res_dep_puiss_par_m: 0.0,
  res_dep_puiss_nec_conduite: 0.0,
  res_dep_vitesse: 0.0,
  res_dep_pdc: 0.0,
  res_ret_puiss_par_m: 0.0,
  res_ret_puiss_nec_conduite: 0.0,
  res_ret_vitesse: 0.0,
  res_ret_pdc: 0.0,
  res_total_deperdition: 0.0,
  res_total_pdc: 0.0,
  res_ret_temp_fin_boucle: 0.0,
  mode: 'none',
  calcul_code: 'I01DEPBOUCECS'
}

export default I01DEPBOUCECS
